import { stripHtml } from "string-strip-html";
import editorModelToHtml from "@/helpers/quill/editorModelToHtml";
import type { EditorModel } from "@/types";

export default (delta: EditorModel) => {
  if (typeof delta === "string") {
    return delta;
  }

  return stripHtml(editorModelToHtml(delta))?.result || "";
};
